<div class="page-wrapper">
  <h1 style="text-align: center; margin-bottom: 20px; font-family: monospace;">Bank Transactions</h1>

	<div *ngIf="loading">Loading transactions...</div>

  <!-- Container to center the table and summary -->
  <div style="display: flex; flex-direction: column; align-items: center;">
    <!-- Summary row (visible when there are transactions) -->
    <div *ngIf="!loading && transactions.length > 0" style="font-size: 24px;margin-bottom: 10px; padding: 10px; background-color: #2c3e50; border-radius: 4px; color: #ecf0f1; text-align: center; font-family: monospace;">
      <strong>Count:</strong> {{filteredTransactions.length}} &nbsp;&nbsp;&nbsp;
      <strong>Amount:</strong>
      <span [style.color]="getFilteredTransactionsSum() >= 0 ? '#2ecc71' : '#e74c3c'">
        {{getFormattedSummaryAmount()}}
      </span>
    </div>

    <!-- Filters and Headers (always visible when there are transactions) -->
    <div class="trx-table" *ngIf="!loading && transactions.length > 0">
		<div>
      <select [(ngModel)]="bankFilter" (change)="onBankFilterChange()">
        <option value="">All</option>
        <option value="Chase">Chase</option>
        <option value="Fidelity">Fidelity</option>
      </select>
    </div>
		<div></div>
		<div><input type="text" [(ngModel)]="descriptionFilter" (input)="onDescriptionFilterChange()" placeholder="Filter by description..." /></div>
		<div></div>
		<div></div>
		<div>
      <select [(ngModel)]="categoryFilter" (change)="onCategoryFilterChange()">
        <option value="">All Categories</option>
        <option *ngFor="let category of getCategoryKeys()" [value]="category">
          {{category}}
        </option>
      </select>
    </div>
		<div></div>
		<div></div>
		<div>
      <select [(ngModel)]="campaignFilter" (change)="onCampaignFilterChange()">
        <option value="">All Campaigns</option>
        <option value="00000000-0000-0000-0000-000000000000">No Campaign</option>
        <option *ngFor="let campaign of sortedCampaigns" [value]="campaign.id">
          {{campaign.name}} ({{getCreatorName(campaign.creatorId)}} {{campaign.createdDate}})
        </option>
      </select>
    </div>
		<div class="header">Bank</div>
		<div class="header">Posted</div>
		<div class="header">Description</div>
		<div class="header right">Amount</div>
		<div class="header">Type</div>
		<div class="header">Category</div>
		<div class="header">Subcategory</div>
		<div class="header">Reimb?</div>
		<div class="header">Campaign</div>

    <!-- Transaction rows (only when there are filtered results) -->
    <ng-container *ngIf="filteredTransactions.length > 0">
      <ng-container *ngFor="let t of filteredTransactions; let i = index">
        <div>{{t.bank}}</div>
        <div>{{t.posted_date}}</div>
        <div 
          class="desc" 
          [class.desc-expanded]="expandedDescriptions[i]"
          (mousedown)="onDescriptionMouseDown($event, i)"
          (mouseup)="onDescriptionMouseUp($event, i)"
          [title]="expandedDescriptions[i] ? 'Click to collapse (or select text to copy)' : 'Click to expand full description'">
          <span *ngIf="!expandedDescriptions[i]">
            {{t.description}}<span *ngIf="t.description.length > 45" class="more-indicator">...</span>
          </span>
          <span *ngIf="expandedDescriptions[i]">
            {{t.description}}
          </span>
        </div>
        <div class="amount-value" [ngClass]="{'amount-negative': t.amount < 0, 'amount-positive': t.amount > 0}">
          {{formatAmount(t.amount)}}
        </div>
        <div>{{t.type}}</div>
        <div>
          <select [(ngModel)]="t.category" (change)="onCategoryChange(t, $any($event.target).value)">
            <option value="">Select Category</option>
            <option *ngFor="let category of getCategoryKeys()" [value]="category">
              {{category}}
            </option>
          </select>
        </div>
        <div>
          <select *ngIf="t.category && hasSubcategories(t.category)"
                  [(ngModel)]="t.subcategory"
                  (change)="onSubcategoryChange(t, $any($event.target).value)">
            <option value="">Select Subcategory</option>
            <option *ngFor="let subcategory of getSubcategoriesForCategory(t.category)" [value]="subcategory">
              {{subcategory}}
            </option>
          </select>
          <span *ngIf="!t.category || !hasSubcategories(t.category)">{{t.subcategory}}</span>
        </div>
        <div class="center">{{t.reimbursable ? 'Yes' : 'No'}}</div>
        <div>
          <select [(ngModel)]="t.campaign_id" (change)="onCampaignChange(t, $any($event.target).value)">
            <option value="">Select Campaign</option>
            <option value="00000000-0000-0000-0000-000000000000">No Campaign</option>
            <option *ngFor="let campaign of sortedCampaigns" [value]="campaign.id">
              {{campaign.name}} ({{getCreatorName(campaign.creatorId)}} {{campaign.createdDate}})
            </option>
          </select>
        </div>
      </ng-container>
    </ng-container>
    </div>

    <div *ngIf="!loading && transactions.length > 0 && filteredTransactions.length === 0">
      No transactions match the current filter.
    </div>

    <div *ngIf="!loading && transactions.length === 0">
      No transactions found.
    </div>
  </div>

</div>
